import React, { useContext } from "react";
import cx from "classnames";

import { TSizes, TVariants } from "../../types";
import { ThemeContextNuO } from "../../nuorder-theme";

import { LoadingIndicator } from "../../loading-indicator";
import { DATATEST } from "./constants";
import { useStyles } from "./button.styles";

type TButtonProps = {
    className?: string;
    type?: "button" | "submit" | "reset";
    style?: React.CSSProperties;
    variant?: Extract<TVariants, "default" | "primary" | "action" | "subtle" | "action">;
    size?: Extract<TSizes, "default" | "large" | "small">;

    children: React.ReactNode;

    disabled?: boolean;
    isLoading?: boolean;

    onClick?: () => void;
};

export const Button = ({ type = "button", variant = "default", size = "default", ...props }: TButtonProps) => {
    const themeContextNuO = useContext(ThemeContextNuO);
    const styles = useStyles(themeContextNuO);

    const buttonVariant = props.isLoading ? "default" : variant;
    const buttonClasses = cx(styles.button, styles[`${buttonVariant}Variant`], styles[`${size}Size`], props.className, {
        [styles.loading]: props.isLoading,
    });

    return (
        <button
            onClick={props.onClick}
            disabled={props.disabled || props.isLoading}
            className={buttonClasses}
            type={type}
            style={props.style}
            data-test={DATATEST.BUTTON}
        >
            {props.isLoading ? <LoadingIndicator size="small" variant={variant} /> : props.children}
        </button>
    );
};
